/**
* @name APP u-Planning
* @autor over.martinez@u-planner.com
* @description
* Descripcion del controlador
* @controller 
* # name: perfildashController
* # alias: perfildashVM
*/

export default class perfildashController {

	constructor($scope, $state, $stateParams, ngNotify, $timeout, GlobalSrv, UserInfoConstant, perfilSrv, $mdDialog, FileUploader, SERVICE_URL_CONSTANT, $cookies, moment, $rootScope, LOCAL_ENV_CONSTANT, GlobalConfig) {
		this.$scope = $scope
		this.$state = $state
		this.$timeout = $timeout
		this.ngNotify = ngNotify
		this.$stateParams = $stateParams
		this.perfilSrv = perfilSrv
		this.userinfo = null
		this.$mdDialog = $mdDialog
		this.moment = moment
		this.$scope.avatar_img = require('../images/avatar_7.png')
		this.$scope.circle_2016 = require('../images/2016_circle.png')
		this.$scope.hat = require('../images/hat.png')
		this.$scope.circle_prp_2016 = require('../images/2016_prp_circle.png')
		this.$scope.back = require('../images/back.png')
		this.$scope.UserInfoConstant = UserInfoConstant
		this.$scope.SERVICE_URL_CONSTANT = SERVICE_URL_CONSTANT
		this.$scope.STATIC_SERVER_DOMAIN = LOCAL_ENV_CONSTANT.STATIC_IMAGE_URL
		this.$scope.rutID = null
		this.$scope.STATIC_IMAGE_URL = false
		this.$scope.STATIC_IMAGE_URL_UPLOAD = true
		this.$scope.noPicture = require('../images/no_user.jpg')
		this.$scope.picture = this.$scope.noPicture
		this.role = null
		this.showModalDetailTeacher = null
		this.gParams = {}
		this.showDatos = false
		this.globalSrv = GlobalSrv
		this.GlobalConfig = GlobalConfig
		this.$cookies = $cookies
		this.loadingData = {
			dpersonales: true, 
			docente    : true,
			extend     : true,
			invest     : true,
			tur        : true,
			formacion  : true,
			reco       : true,
			tprevia    : true,
		}

		this.$scope.$watch('UserInfoConstant[0].details[0]', (details, before) => {
			if (details !== undefined) {
				this.userinfo = details.user
				this.userinfo.role_id = this.$cookies.get('hasRoleId')
				this.viewPencil = (this.userinfo.role_id == 13) ? false : true
				this.main()
			}
		})

		this.$scope.fileNameChanged = function() {
			this.$scope.STATIC_IMAGE_URL_UPLOAD = false
		}

		var uploader = this.$scope.uploader = new FileUploader({
			url: SERVICE_URL_CONSTANT.rosario + '/perfil/setProfileImage',
		})

		uploader.filters.push({
			name: 'imageFilter',
			fn  : function(item, options) {
				var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|'

				return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1
			},
		})
		uploader.onSuccessItem = function(fileItem, response, status, headers) {
			console.info('onSuccessItem', fileItem, response, status, headers)
		}
		uploader.onErrorItem = function(fileItem, response, status, headers) {
			console.info('onErrorItem', fileItem, response, status, headers)
		}
		var THIS = this

		uploader.onCompleteItem = function(fileItem, response, status, headers) {
			console.info('onCompleteItem', fileItem, response, status, headers)
			THIS.$scope.STATIC_IMAGE_URL = true
			THIS.$scope.picture = response.data + '?' + Math.random()
			THIS.$scope.STATIC_IMAGE_URL_UPLOAD = true
			THIS.ngNotify.set('La foto de perfil se ha subido', 'success')
			$rootScope.$emit('profileimagechange', {})
			//$scope.pictureRosario = 'https://urosariostorage.blob.core.windows.net/profilepicture/'+$scope.rut+'.jpg?1'+$scope.mathRandom
		}

		uploader.onBeforeUploadItem = function(item) {
			item.formData = []
			item.formData.push({ id: THIS.$scope.rutID })
			THIS.$scope.STATIC_IMAGE_URL_UPLOAD = true
		}

		const config = require('../../../../../../local.env.json')

		this.staticServerurl = config.STATIC_IMAGE_URL
	}

	main() {
		this.perfilSrv.role.getType({ param1: this.userinfo.role_id }).$promise.then((response) => {
			if (!response.status) {
				return this.ngNotify.set('Ocurrio un error en el servicio', 'warn')
			} 
      
			this.role = response.data[0]
			this.userIsNotATeacher = this.role.types !== 'TEACHER'
			this.showModalDetailTeacher = this.role.id_code != 4

			if (this.userIsNotATeacher) {
				this.showSelect = true
          
				if (this.$stateParams.teacherId) {
					this.onTeacherChange(this.$stateParams.teacherId)
				}
			} else {
				this.showSelect = false
				this.getInfoProfile()
			}
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error')
		})
	}

	viewDetails(det) {
		this.urls = {
			perfil_docente      : 'profile.perfil_docente', 
			perfil_investigation: 'profile.perfil_investigation', 
			perfil_extencion    : 'profile.perfil_extencion', 
			UR_trajectory       : 'profile.UR_trajectory', 
			perfilde_formacion  : 'profile.perfilde_formacion', 
			Reconocimientose_inc: 'profile.Reconocimientose_inc', 
			Trayectoria_Previa  : 'profile.Trayectoria_Previa', 
		}

		if (this.gParams.teacherId !== undefined) {
			this.$state.go(this.urls[det], this.gParams)
		}
	}

	getInfoProfile() {
		this.perfilSrv.role.getInfo({ param1: this.userinfo.id }).$promise.then((response) => {
			if (!response.status) {
				this.ngNotify.set('Ocurrio un error en el servicio', 'warn')
			} else {
				this.userinfo.teacherId = response.data[0].idTeacher
				this.callingAllServices(this.userinfo.teacherId)
			}
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error')
		})
	}

	callingAllServices(teacherId) {
		this.show = true
		this.gParams = { teacherId: teacherId }
		this.getTeacherInfo(teacherId)
		this.getperfildocenteChart(teacherId)
		this.perfilextentionChart(teacherId)
		this.PerfildeInvestigacionChart(teacherId)
		this.TrayectoriaURGraph(teacherId)
		this.trayectoriaprevia(teacherId)
		this.perfilFormacion(teacherId)
		this.reconocimientros(teacherId)
		this.showDatos = true
	}

	getperfildocenteChart(teacherId) {
		this.loadingData.docente = true
		this.perfilSrv.perfildocente.getperfildocenteChart({ teacherId: teacherId }).$promise.then((response) => {
			if (!response.status) {
				this.ngNotify.set('Ocurrio un error en el servicio', 'warn')
			} else {
				this.chartDocente = Highcharts.chart('perfil_chart_d', {
					chart   : { type: 'column' },
					title   : { text: 'Última actualización el ' + response.data.lastUpdate },
					subtitle: {
						useHTML : true,
						text    : '<p>Asignaturas Dictadas por Nivel</p>',
						floating: true,
						style   : {
							fontSize  : '9px',
							fontWeight: 'bold',
						},
						align: 'center',
						x    : -10,
						y    : 255,
					},
					xAxis: {
						categories: response.data.category, 
						labels    : { x: -10 } },
					yAxis: {
						tickInterval : 1,
						minRange     : 1,
						allowDecimals: false,
						title        : { text: '' } },
					series     : response.data.series,
					plotOptions: { column: { stacking: 'normal' } },
					size       : { height: '300' },
					tooltip    : {
						formatter: function () {
							return '<b>' + this.x + '</b><br/>' +
              this.series.name + ': ' + this.y + '<br/>' +
              'Total: ' + this.point.stackTotal
						},
					},
					credits: false,
				})
				this.loadingData.docente = false
			}
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error')
		})
	}

	PerfildeInvestigacionChart(teacherId) {
		this.loadingData.invest = true
		this.perfilSrv.perfildocente.PerfildeInvestigacionChart({ teacherId: teacherId }).$promise.then((response) => { 
			this.cartInves = Highcharts.chart('perfil_inv_d', {
				chart   : { type: 'column' },
				title   : { text: 'Última actualización el ' + response.data.lastUpdate },
				subtitle: {
					useHTML : true,
					text    : '<p>Producción Científica</p>',
					floating: true,
					style   : {
						fontSize  : '9px',
						fontWeight: 'bold',
					},
					align: 'center',
					x    : -10,
					y    : 255,
				},
				xAxis: { categories: response.data.category, labels: { x: -10 } },
				yAxis: {
					tickInterval : 1,
					minRange     : 1,
					allowDecimals: false,
					title        : { text: '' } },
				series     : response.data.series,
				plotOptions: { column: { stacking: 'normal' } },
				size       : { height: '300' },
				tooltip    : {
					formatter: function () {
						return '<b>' + this.x + '</b><br/>' +
            this.series.name + ': ' + this.y + '<br/>' +
            'Total: ' + this.point.stackTotal
					},
				},
				credits: false,
			})
			this.loadingData.invest = false
		}, (data) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error')
		})
	}

	perfilextentionChart(teacherId) {
		this.loadingData.extend = true
		this.perfilSrv.perfildocente.perfilextentionChart({ teacherId: teacherId }).$promise.then((response) => {   
			this.chartExt = Highcharts.chart('perfil_ext_d', {
				chart   : { type: 'column' },
				title   : { text: 'Última actualización el ' + response.data.lastUpdate },
				subtitle: {
					useHTML : true,
					text    : '<p>Actividades de Extensión Realizadas</p>',
					floating: true,
					style   : {
						fontSize  : '9px',
						fontWeight: 'bold',
					},
					align: 'center',
					x    : -10,
					y    : 255,
				},
				xAxis: { categories: response.data.category, labels: { x: -10 } },
				yAxis: {
					tickInterval : 1,
					minRange     : 1,
					allowDecimals: false,
					title        : { text: '' } },
				series     : response.data.series,
				plotOptions: { column: { stacking: 'normal' } },
				size       : { height: '300' },
				tooltip    : {
					formatter: function () {
						return '<b>' + this.x + '</b><br/>' +
            this.series.name + ': ' + this.y + '<br/>' +
            'Total: ' + this.point.stackTotal
					},
				},
				credits: false,
			})
			this.loadingData.extend = false
		}, (data) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error')
		})
	}

	TrayectoriaURGraph(teacherId) {
		this.loadingData.tur = true
		this.perfilSrv.perfildocente.TrayectoriaURGraph({ teacherId: teacherId }).$promise.then((response) => {   
			this.singleName = response.data[0] || {}
			this.loadingData.tur = false
		}, (data) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error')  
		})
	}

	perfilFormacion(teacherId) {
		this.loadingData.formacion = true
		this.perfilSrv.perfildocente.perfilFormacion({ teacherId: teacherId }).$promise.then((dataReturn) => {
			this.lastFormation = dataReturn.data[0] || {}
			this.lastFormation.end_date = dataReturn.maxYear
			this.lastFormation.Convalescence = this.moment(this.lastFormation.Convalescence).format('DD-MM-YYYY')
			this.loadingData.formacion = false
		}, (data) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error')
		})
	}

	reconocimientros(teacherId) {
		this.loadingData.reco = true
		this.perfilSrv.perfildocente.reconocimientoSeincentivos({ teacherId: teacherId }).$promise.then((response) => {
			if (!response.status) {
				this.ngNotify.set('Ocurrio un error en el servicio', 'warn')
			} else {
				this.lastAck = response.data[0] || {}
			}

			this.loadingData.reco = false
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error')
		})        
	}

	trayectoriaprevia(teacherId) {
		this.loadingData.tprevia = true
		this.perfilSrv.perfildocente.trayectoriaprevia({ teacherId: teacherId }).$promise.then((dataReturn) => {  
			this.registrosTP = dataReturn.data.length
			this.trayectoriaPrevia = dataReturn.data[0]
			this.loadingData.tprevia = false
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error')
		})
	}
  
	getTeacherInfo(teacherId) {
		this.$scope.loading = true
		this.loadingData.dpersonales = true
		this.dataInfo = {}
		this.perfilSrv.perfildocente.getperfil_dash({ teacherId: teacherId }).$promise.then((response) => { 
			if (!response.status) {
				this.ngNotify.set('Ocurrio un error en el servicio', 'warn')
			} else {
				this.dataInfo = response.data[0] || {}
				this.$scope.items = response.data 
				this.$scope.loading = false
				this.$scope.rutID = this.dataInfo.identification_number

				const self = this
				const currentUser = this.$cookies.getObject('currentUser')
				const mathRandom = Math.random()

				if (!this.userIsNotATeacher && currentUser) {
					if (currentUser.pictureExtension) {
						this.$scope.picture = this.staticServerurl + '/profilepicture/' + currentUser.pictureExtension + '?1=' + mathRandom
					} else if (currentUser.pictureRosario) {
						this.$scope.picture = currentUser.pictureRosario
					}
				} else if (this.$scope.rutID) {
					this.globalSrv.getUserImage.get({ identification: this.$scope.rutID }).$promise.then((response) => {
						self.$scope.picture = response.profilePicture + '?1=' + mathRandom
					})
				}
			}

			this.loadingData.dpersonales = false
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error')
		})
	}

	getTeacherInfoByRoleUser() {
    
	}

	returnBack () {
		window.history.back()
	}

	editComments() {
		var confirm = this.$mdDialog.confirm({
			controller         : 'modalEditCommentsCtrl',
			controllerAs       : 'modalVM',
			template           : require('./dialog/modalCommentEdit.html'),
			locals             : { services: this.perfilSrv.post, dataInfo: this.dataInfo },
			animation          : true,
			parent             : angular.element(document.body),
			clickOutsideToClose: true,
		})

		this.$mdDialog.show(confirm)
	}

	areasOfInterest() {
		var confirm = this.$mdDialog.confirm({
			controller         : 'areasOfInterestCtrl',
			controllerAs       : 'modalVM',
			template           : require('./dialog/areasOfInterest.html'),
			locals             : { services: this.perfilSrv.post, dataInfo: this.dataInfo },
			animation          : true,
			parent             : angular.element(document.body),
			clickOutsideToClose: true,
		})

		this.$mdDialog.show(confirm)
	}

	searchingTeacher(typing) {
		if (typing.length > 2) {
			const params = { 
				param1: typing, 
				param2: this.userinfo.role_id,
				param3: this.userinfo.id,
			}

			this.perfilSrv.list.getListDocentes(params).$promise.then((response) => {
				if (!response.status) {
					this.ngNotify.set('Ocurrio un error en el servicio', 'warn')
				} else {
					this.listTeachers = response.data
				}
			}, (err) => {
				this.ngNotify.set('Imposible conectar con el servicio', 'error')
			})
		}
	}

	onTeacherChange(teacherId) {
		this.showDatos = false
		this.$scope.picture = this.$scope.noPicture
		this.callingAllServices(teacherId)
	}

	showModal () {
		var confirm = this.$mdDialog.confirm({
			controller         : 'perfil_popcontroller',
			controllerAs       : 'perfildashVM',
			template           : require('./dialog/per_dash_popdetail.html'),
			locals             : { datos: this.dataInfo },
			animation          : true,
			parent             : angular.element(document.body),
			clickOutsideToClose: true,
		})

		this.$mdDialog.show(confirm)
	} 

}

perfildashController.$inject = [ '$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'GlobalSrv', 'UserInfoConstant', 'perfilSrv', '$mdDialog', 'FileUploader', 'SERVICE_URL_CONSTANT', '$cookies', 'moment', '$rootScope', 'LOCAL_ENV_CONSTANT', 'GlobalConfig' ]



// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/perfil_dash/perfildashController.js